import React, {FC} from "react";
import {Card, Col, Form, Row} from "react-bootstrap";
import {Field, useFormikContext} from "formik";
import {FormikRowCheckbox} from "@components/panel/formik";
import {GoalInput} from "@components/consumer/helpers";

export interface RefTargetFormValues {
    goalId: string;
    isActive: boolean;
}

interface RefTargetBaseInfoBlockProps {
    editForm?: boolean;
}

const RefTargetBaseInfoBlock: FC<RefTargetBaseInfoBlockProps> = ({editForm}) => {
    const {values, setFieldValue, errors} = useFormikContext<RefTargetFormValues>();

    return (
        <Card className="mb-3">
            <Card.Header as="h6" className="bg-body-tertiary">Цель</Card.Header>
            <Card.Body>
                <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={3}>Достижение</Form.Label>
                    <Col sm={9}>
                        <GoalInput
                            name="goalId"
                            value={values.goalId}
                            setFieldValue={setFieldValue}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.goalId}
                        </Form.Control.Feedback>
                    </Col>
                </Form.Group>

                {editForm && (
                    <Field
                        label="Активно"
                        name="isActive"
                        type="switch"
                        id="target-active"
                        component={FormikRowCheckbox}
                    />
                )}
            </Card.Body>
        </Card>
    );
};

export default RefTargetBaseInfoBlock;
